module.exports = __webpack_public_path__ + "media/images/hp-f0001714b1fe310ecc171c9339244e3c.webp";